'use strict';
/*
* Modal Video Window
* @package krobot
* @deps modal-video
*/

new ModalVideo( '.js-modal-btn' ); // eslint-disable-line
new ModalVideo( '.js-modal-btn-vimeo', { channel: 'vimeo' } ); // eslint-disable-line
